import React, { useState, useEffect } from "react";
import "./calendar.css";
import "react-big-calendar/lib/css/react-big-calendar.css";

function CalendarScheduleSet() {
    const [schedule, setSchedule] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSchedule = async () => {
            try {
                const response = await fetch("https://meetmind.ru/v1/spec/get-user-schedule");
                if (!response.ok) {
                    throw new Error("Ошибка загрузки расписания");
                }
                const data = await response.json();
                setSchedule(data.schedule);
            } catch (error) {
                console.error("Ошибка:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchSchedule();
    }, []);

    const handleSlotClick = async (event) => {
        if (event.is_occupied) return;

        const therapyId = sessionStorage.getItem("meetmindSelectedTherapy");
        if (!therapyId) return;

        const requestData = {
            date: event.date,
            therapy_id: therapyId,
        };

        try {
            const response = await fetch("https://meetmind.ru/v1/spec/create-schedule", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            if (!response.ok) {
                throw new Error("Ошибка записи сессии в календарь");
            }

            alert("Сессия успешно записана!");
            window.location.href = "/schedule";
        } catch (error) {
            console.error("Ошибка записи сессии в календарь:", error);
        }
    };

    if (loading) {
        return <div>Загрузка...</div>;
    }

    if (!schedule) {
        return <div>Ошибка загрузки данных</div>;
    }

    return (
        <div>
            <div className="flex-head mb-1">
                <button className="button-arrow">
                    <i className="fa-solid fa-angle-left"></i>
                </button>
                <div className="display-contents">
                    <p className="mx-1 color-grey">{schedule.prev_week}</p>
                    <p className="mx-1 color-blue">{schedule.current_week}</p>
                    <p className="mx-1 color-grey">{schedule.next_week}</p>
                </div>
                <button className="button-arrow">
                    <i className="fa-solid fa-angle-right"></i>
                </button>
            </div>
            <table className="calendar-class">
                <thead className="blue-head">
                    <tr>
                        <th className="th-class"></th>
                        {schedule.days.map((day, index) => (
                            <th key={index} className="th-class">
                                {day.name + " " + day.date_str}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="body-class">
                    {schedule.times.map((time, index) => (
                        <tr key={index}>
                            <td className="td-class">{time.name}</td>
                            {time.events.map((event, idx) => (
                                <td
                                    key={idx}
                                    className={
                                        "td-class " + (event.is_disabled ? "disabled-td" : "we")
                                    }
                                >
                                    <div>
                                        {!event.is_occupied && (
                                            <div onClick={() => handleSlotClick(event)}>
                                                <i
                                                    className="fa-solid fa-square cursor_pointer"
                                                    style={{ color: "#FFA630" }}
                                                ></i>
                                            </div>
                                        )}
                                        {event.is_occupied && event.is_lead && (
                                            <div>
                                                <i
                                                    className="fa-solid fa-user person-class"
                                                    title={`${event.therapy_name}\n${event.therapy_type}`}
                                                />
                                            </div>
                                        )}
                                        {event.is_occupied && !event.is_lead && (
                                            <div>
                                                <i
                                                    className="fa-solid fa-user person-class-secondary"
                                                    title={`${event.therapy_name}\n${event.therapy_type}`}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default CalendarScheduleSet;
